RivalIQ.apps.Reports.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    widgets.DateFilter = Marionette.ItemView.mixin({
        template: '#reportsDateFilterTemplate',
        tagName: 'span',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            menuItems: '.dropdown-selector a'
        },

        behaviors: {
            DropdownSelector: {
                initialTrigger: true
            }
        },

        defaultSelector: function () {
            const me = this;

            return `[data-date-id="${me.getProp('dateId')}"]`;
        },

        onSelectDropdown: function (data) {
            const me = this;
            me.setProps('dateId', data.dateId);
        },

        templateHelpers: function () {
            return {
                dates: App.data.dates.toJSON()
            };
        }
    });
});
